import { Fade } from "@mui/material";
import { useEffect, useState } from "react";

export default function FadeIn({ isLoading = null, children }) {
  const [loaded, setLoaded] = useState(isLoading ?? false);

  // if isLoading is null we set loaded after the first render
  useEffect(() => {
    if (isLoading === null) {
      // Intentional: triggers the Fade enter animation on mount. Setting
      // `loaded` during render would start already-visible with no transition.
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLoaded(true);
    }
  }, []);

  // if isLoading is false we rely on prop change to set loaded
  useEffect(() => {
    if (isLoading === null) return;
    // Intentional: drive the enter/exit animation from the isLoading prop.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLoaded(!isLoading);
  }, [isLoading]);

  return (
    <Fade in={loaded} timeout={1000}>
      {children}
    </Fade>
  );
}
